// This file exposes the application version from package.json
// It's used to display the version in the UI and console

// Import the version from package.json
import packageJson from '../../package.json';

// Export the version
export const APP_VERSION = packageJson.version;
